import 'babel-polyfill';
import 'es6-shim';
import "lodash";
import "moment";
import "angular";
import "angular-animate";
import "angular-aria";
import "angular-block-ui";
import "angular-gettext";
import "angular-material";
import "angular-messages";
import "angular-resource";
import "angular-wizard";
import "angular-moment";
import "angular-sanitize";
import "angular-ui-grid";
import "mdPickers";
import "./app/assets/vendor-static/angularPrint/angularPrint";
import "./node_modules/angular1-component-router";
import  './node_modules/angular-recaptcha'
import "linq-es5";
import "url-pattern";
import "./node_modules/ng-quill"

class VendorModules {
    public ngAnimate: string = "ngAnimate";
    public ngRouter: string = "ngComponentRouter";
    public ngSanitize: string = "ngSanitize";
    public ngMessages: string = "ngMessages";
    public ngMaterial: string = "ngMaterial";
    public ngWizard: string = "mgo-angular-wizard";
    public ngBlockUI: string = "blockUI";
    public ngPrint: string = "AngularPrint";
    public ngMoment: string = "angularMoment"; 
    public ngGetText: string = "gettext";
    public ngUiGrid: string = "ui.grid";
    public ngUiGridAutoResize: string = "ui.grid.autoResize";
    public ngUiGridResizeColumns: string = "ui.grid.resizeColumns";
    public ngUiGridSelection: string = "ui.grid.selection";
    public ngUiGridPinning: string = "ui.grid.pinning";
    public ngUiGridInfiniteScroll: string = "ui.grid.infiniteScroll";
    public ngQuill: string = "ngQuill";
    public mdPickers: string = "mdPickers";   
    public vcRecaptcha: string= "vcRecaptcha";
}

let mods = new VendorModules();
export default mods;
export { mods as Vendor }
   



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./vendor-modules.ts